var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen",class:[`bg-${_vm.$route.meta.background}`]},[(_vm.$route.meta.eggos !== undefined)?_c('eggos',{attrs:{"color":_vm.$route.meta.eggos}}):_vm._e(),_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }